var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.4 141.4",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.7, 70.7) rotate(45) translate(-70.7, -70.7)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "70.7,0 141.4,70.7 70.7,141.4",
    fill: "none",
    stroke: "rgba(255,255,255,0.8)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.7,0 0,70.7 70.7,141.4",
    fill: "none",
    stroke: "rgba(255,255,255,0.8)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0,70.7 70.7,0 70.7,141.4",
    fill: "none",
    stroke: "rgba(255,255,255,0.8)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.4,70.7 70.7,0 70.7,141.4",
    fill: "none",
    stroke: "rgba(255,255,255,0.8)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.7,
    y1: 0,
    x2: 70.7,
    y2: 70.7,
    stroke: "rgba(255,255,255,0.6)",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.7,
    y1: 0,
    x2: 35.35,
    y2: 70.7,
    stroke: "rgba(255,255,255,0.6)",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.7,
    y1: 0,
    x2: 106.05,
    y2: 70.7,
    stroke: "rgba(255,255,255,0.6)",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.7,
    y1: 141.4,
    x2: 70.7,
    y2: 70.7,
    stroke: "rgba(255,255,255,0.6)",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.7,
    y1: 141.4,
    x2: 35.35,
    y2: 70.7,
    stroke: "rgba(255,255,255,0.6)",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70.7,
    y1: 141.4,
    x2: 106.05,
    y2: 70.7,
    stroke: "rgba(255,255,255,0.6)",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 70.7,
    x2: 70.7,
    y2: 70.7,
    stroke: "rgba(255,255,255,0.6)",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 70.7,
    x2: 70.7,
    y2: 35.35,
    stroke: "rgba(255,255,255,0.6)",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 70.7,
    x2: 70.7,
    y2: 106.05,
    stroke: "rgba(255,255,255,0.6)",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.4,
    y1: 70.7,
    x2: 70.7,
    y2: 70.7,
    stroke: "rgba(255,255,255,0.6)",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.4,
    y1: 70.7,
    x2: 70.7,
    y2: 35.35,
    stroke: "rgba(255,255,255,0.6)",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.4,
    y1: 70.7,
    x2: 70.7,
    y2: 106.05,
    stroke: "rgba(255,255,255,0.6)",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.7,
    cy: 70.7,
    r: 4,
    fill: "rgba(255,255,255,0.8)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSquare);
export default __webpack_public_path__ + "static/media/logo-square.3436516e7dca6393902b02625ea08d1f.svg";
export { ForwardRef as ReactComponent };